/* eslint-disable camelcase */
export const relayTimetableExport = {
    export_timetable: "Export timetable",
    format: "Format",
    format_description: "Distances are exported in meters and speeds in miles per hour, whatever units the table is showing.",
    json_description: "Everything in the timetable, nested by team and stage.",
    csv_description: "One row per segment, ready for a spreadsheet.",
    kml_description: "Segments with their geometry, for Google Earth and GIS tools.",
    export_format: "Export {{ format }}",
    stages: "Stages",
    stages_description: "Each stage is exported with every segment inside it.",
    all_stages: "All stages",
    stages_selected: "{{ count }} of {{ total }} selected",
    convoy: "Team",
    convoy_segments: "Team-level segments",
    convoy_segments_description: "The transfers and breaks which sit between stages rather than inside one.",
    include: "Include",
    leave_out: "Leave out",
} as const;
